module.exports = __webpack_public_path__ + "img/avatar.937d53bc.svg";